import { render, staticRenderFns } from "./sendpulse_fields_tab.vue?vue&type=template&id=7c55a858&"
import script from "./sendpulse_fields_tab.vue?vue&type=script&lang=js&"
export * from "./sendpulse_fields_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c55a858')) {
      api.createRecord('7c55a858', component.options)
    } else {
      api.reload('7c55a858', component.options)
    }
    module.hot.accept("./sendpulse_fields_tab.vue?vue&type=template&id=7c55a858&", function () {
      api.rerender('7c55a858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/sendpulse/location/tabs/sendpulse_fields_tab.vue"
export default component.exports